import { useNavigate } from 'react-router-dom';
import axiosInstance from '../utils/axiosInstance';
import GlobalError from '../components/GlobalError';
import useDataFetch from '../hooks/useDataFetch';
import { getFields, searchFields } from '../utils/fields';
import { formatDateTime, formatCurrency } from '../utils/format';
import SearchForm from '../components/SearchForm';
import TableView from '../components/TableView';
import Pagination from '../components/Pagination';
import { Link as RouterLink } from 'react-router-dom';
import { Link, Button, Stack, Typography, Paper } from '@mui/material';

const OrdersPage = () => {
  const navigate = useNavigate();
  // useDataFetch フックを使用してデータ取得・管理
  const {
    dataset,
    loading,
    error,
    currentPage,
    totalPages,
    searchQuery,
    handleSearchChange,
    handleSearchSubmit,
    handleClearSearch,
    handlePageChange,
  } = useDataFetch('/order', { order_numbers: '', dates: '' });

  // 検索フィールド定義
  const fieldsToInclude = ['dates', 'order_numbers'];
  let searchItems = getFields(searchFields, fieldsToInclude);

  const columns = [
    {
      label: '注文日',
      accessor: 'order_date',
      format: (date) => formatDateTime(date),
    },
    {
      label: '注文番号',
      accessor: 'order_number',
      render: (item) => (
        <Link
          component={RouterLink}
          to={`/orders/${item.order_id}`}
          underline="hover"
        >
          {item.order_number}
        </Link>
      ),
    },
    {
      label: 'ステータス',
      accessor: 'order_status_name',
      render: (item) => {
        // 04,05,06 は「発送準備中」、それ以外はそのまま
        if (['04', '05', '06'].includes(item.order_status_id)) return '発送準備中';
        return item.order_status_name;
      }
    },
    {
      label: '金額',
      accessor: 'total_amount',
      render: (item) => {
        return (
          <>
            <Typography>{formatCurrency(item.total_amount)}</Typography>
            <Typography variant='caption'>税込{formatCurrency(item.total_amount_including_tax)}</Typography>
          </>
        );
      },
    },
    {
      label: '',
      render: (item) => (
        <>
          <Stack direction="row" spacing={1}>
            <Button
              variant="outlined"
              size="small"
              onClick={() => navigate(`/orders/${item.order_id}`)}
            >
              詳細
            </Button>
            <Button
              variant="contained"
              size="small"
              color="primary"
              onClick={() => reorder(item.order_id)}
            >
              再注文
            </Button>
          </Stack>
        </>
      ),
      width: '140px',
    },
  ];
  const reorder = async (orderId, orderItemIds = []) => {
    try {
      await axiosInstance.post('/cart/reorder', {
        order_id: orderId,
        order_item_ids: orderItemIds, // 空なら注文全体
      });

      alert('カートに追加しました');
      navigate('/cart'); // カートページへ
    } catch (error) {
      alert('カートに追加できませんでした');
    }
  };
  if (error) return <GlobalError errorMessage={error} />;

  return (
    <>
      <Typography variant="h1">ご注文履歴</Typography>
      <Typography mb={2}>過去にいただいたご注文一覧です。同じ注文内容で再発注を行うこともできます。</Typography>
      {/* 検索フォーム */}
      <SearchForm
        searchQuery={searchQuery}
        searchFields={searchItems}
        handleSearchChange={handleSearchChange}
        handleSearchSubmit={handleSearchSubmit}
        handleClearSearch={handleClearSearch}
      />
      <Paper variant='section'>
        {dataset.length === 0 ? (
          <>データがありません</>
        ) : (
          <>
            <TableView dataset={dataset} columns={columns} />
            <Pagination
              currentPage={currentPage}
              totalPages={totalPages}
              onPageChange={handlePageChange}
            />
          </>
        )}
      </Paper>

    </>
  );
};


export default OrdersPage;
